import React from "react";
import {surveyOptions} from "../../constant";
import {Typography} from "../../../../designSystem/components/Typography";

interface SatisfactionRadioGroupProps {
  name: string;
  value: string;
  onChangeValue: (value: string) => void;
}

export const SatisfactionRadioGroup = ({
  name,
  value,
  onChangeValue
}: SatisfactionRadioGroupProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChangeValue(event.target.value);
  };

  return (
    <div className="flex justify-center mt-3">
      <div className="grid grid-cols-6 gap-2 w-full max-w-xl">
        {surveyOptions.map((option) => (
          <label
            key={option}
            className="flex flex-col items-center space-y-1 w-full"
          >
            <Typography
              variant="caption"
              className="text-gray-700 text-center"
            >
              {option}
            </Typography>
            <input
              type="radio"
              name={`satisfaction-radio-group-${name}`}
              value={option}
              checked={value === option}
              onChange={handleChange}
              className="form-radio h-5 w-5 text-ptTeal"
            />
          </label>
        ))}
      </div>
    </div>
  );
};
